import { defineComponent as o, Types as e } from "bitecs";
const i = o({
  moveX: e.f32,
  moveY: e.f32,
  moveZ: e.f32,
  lookX: e.f32,
  lookY: e.f32,
  scrollDelta: e.f32,
  jump: e.ui8,
  primaryAction: e.ui8,
  secondaryAction: e.ui8,
  leftMouse: e.ui8,
  rightMouse: e.ui8,
  middleMouse: e.ui8,
  jumpBufferTime: e.f32,
  primaryBufferTime: e.f32,
  secondaryBufferTime: e.f32
});
export {
  i as InputState
};
//# sourceMappingURL=components.js.map
